// @flow
import React, { useState, useCallback } from 'react';
import { navigate } from '@reach/router';

import { sparePartsApi } from '../../lib/api';
import type { UserAccess, SpareParts, VehicleModel } from '../../lib/types';
import { getBreadCrumbsByUrlForCard } from '../../lib/autoBreadcrumbs';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import Grid, { GridItem } from '../../components/layout/Grid';
import { Card } from '../../components';

import { withUserAccess } from './../withUserAccess';

import { addAccessRight } from './accessRight';
import { sparePartMaterialTypes } from '../../lib/enum';

const { Field } = Card;

type InnerProps = {
  data: SpareParts
};

type PageProps = {
  id: string,
  userAccess: UserAccess[]
};

const entryPointPath = '/admin/spare-parts/';

const InnerForm = (props: InnerProps) => {
  return (
    <>
      <Grid gutter="16px" noWrapMe={false}>
        <GridItem>
          <Field label="Название">{props.data.name}</Field>
        </GridItem>
        <GridItem>
          <Field label="Каталожный номер">{props.data.catalogNumber}</Field>
        </GridItem>
        <GridItem>
          <Field label="Стоимость, руб. без НДС">{props.data.price}</Field>
        </GridItem>
        <GridItem>
          <Field label="Ед. измерения">{props.data.unit?.alias}</Field>
        </GridItem>
        <GridItem>
          <Field label="Тип материала">
            {props.data.type ? sparePartMaterialTypes[props.data.type] : '-'}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Применяемость">
            {props.data.vehicleModels
              ?.map(
                (vehicleModel: VehicleModel) =>
                  `${vehicleModel.name} ${vehicleModel.brandName}`
              )
              .join(',')}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Примечание">{props.data.note}</Field>
        </GridItem>
      </Grid>
    </>
  );
};

export default withUserAccess((props: PageProps) => {
  const [data: SpareParts, setData] = useState({
    id: +props.id,
    name: '',
    price: 0,
    unidId: 0,
    unit: null,
    vehicleModels: []
  });

  const breadCrumbs = getBreadCrumbsByUrlForCard(entryPointPath, data.id);

  const canEdit = props.userAccess.some(access =>
    addAccessRight.includes(access)
  );

  const access = {
    delete: canEdit
      ? async () => {
          await sparePartsApi.delete(data.id);
          await navigate(`${entryPointPath}`);
        }
      : false,
    edit: canEdit
      ? async () => await navigate(`${entryPointPath}edit/${data.id}`)
      : false
  };

  const onFetch = useCallback(async () => {
    setData(await sparePartsApi.get(props.id));
  }, [props.id]);

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Запасные части',
        access
      }}
      onFetch={onFetch}
    >
      <InnerForm data={data} />
    </CommonCardPage>
  );
});
